import { createSlice } from '@reduxjs/toolkit';

export const clinicasSlices = createSlice({
    name: "clinicasSlices",
    initialState: {
        loadingClinicas: false,
        clinicas: []
    },
    reducers: {
        loadClinicas: (state) => {
            state.loadingClinicas = true;
        },
        setClinicas: (state, action) => {
            state.loadingClinicas = false;
            state.clinicas = action.payload.clinicas
        }
    }
});

export const { loadClinicas, setClinicas } = clinicasSlices.actions;